import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import reduxUtils from 'util/redux';
import getOrderState from 'util/misc/get-order-state';

import Cart from 'components/cart';
import { Trans } from 'translations';
import { PROFILE_ORDERS } from 'constants/page-names';
import linkToHome from 'util/misc/link-to-home';

class DeliveryNotification extends PureComponent {
    static propTypes = {
        closeModal: PropTypes.func.isRequired,
        history: PropTypes.object,
        openModal: PropTypes.func.isRequired,
        openPanel: PropTypes.func.isRequired,
        routerRegistry: PropTypes.object.isRequired,
        setStatus: PropTypes.func.isRequired,
        status: PropTypes.string.isRequired,
        activeRegion: PropTypes.object,
    };

    componentWillReceiveProps({ status }) {
        const { status: oldStatus } = this.props;

        // Status changed
        if (status !== oldStatus) {
            this.dispatchModal(status);
        }
    }

    /**
     * Check if the status change requires the dispatching of a modal screen
     * @param status
     */
    dispatchModal(status) {
        const { isShipped, isFailed } = getOrderState(status);
        if (isShipped) {
            this.successModal();
        } else if (isFailed) {
            this.errorModal();
        }
    }

    successModal() {
        this.props.openModal({
            meta: {
                title: <Trans path={'delivery.success_title'}/>,
                description: <Trans path={'delivery.success_description'}/>,
                type: 'success',
                icon: {
                    size: 'large',
                    symbol: 'success',
                },
                actions: [
                    {
                        name: <Trans path={'delivery.goto_home'}/>,
                        facet: 'secondary',
                        event: () => {
                            this.props.history.replace(linkToHome(this.props.activeRegion));
                            this.props.closeModal();
                        },
                    },
                    {
                        name: <Trans path={'delivery.goto_order_details'}/>,
                        event: () => {
                            this.props.history.replace(this.props.routerRegistry.get(PROFILE_ORDERS).url);
                            this.props.closeModal();
                        },
                    },
                ],
            },
            layout: 'confirm',
        });
    }

    errorModal() {
        this.props.openModal({
            meta: {
                title: <Trans path={'delivery.timeout_title'}/>,
                description: <Trans path={'delivery.timeout_description'}/>,
                type: 'error',
                icon: {
                    size: 'large',
                    symbol: 'alert',
                },
                actions: [
                    {
                        name: <Trans path={'delivery.goto_home'}/>,
                        facet: 'secondary',
                        event: () => {
                            this.props.history.replace(linkToHome(this.props.activeRegion));
                            this.props.closeModal();
                        },
                    },
                    {
                        name: <Trans path={'delivery.goto_cart'}/>,
                        event: () => {
                            this.props.history.replace(linkToHome(this.props.activeRegion));
                            this.props.closeModal();
                            requestAnimationFrame(() => {
                                this.props.openPanel({ facet: 'cart', content: <Cart/> });
                            });
                        },
                    },
                ],
            },
            layout: 'confirm',
        });
    }

    render() {
        return null;
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        status: 'delivery.status',
        history: 'router.history',
        routerRegistry: 'router.registry',
        activeRegion: 'region.active',
    }),
    reduxUtils.mapDispatchToProps({
        openModal: 'modal.open',
        closeModal: 'modal.close',
        setStatus: 'delivery.setStatus',
        openPanel: 'panel.open',
    }),
)(DeliveryNotification);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/delivery-notification/index.js